<template>
  <BaseNew
    @new-confirm-action="createEntry"
    @new-cancel-action="resetForm"
    @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors"
    ref="baseNew"
    width="50%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :inlineAddButton="inlineAddButton"
    :createButtonDisabled="!$can('create','Brand')"
  >
    <template slot="newForm">
      <Form
        ref="form"
        :entry="entry"
        :extraData="extraData"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      entry: null,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    inlineAddButton: {
      type: Boolean,
      default: false
    },
    withType: String,
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function() {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_NEW_BRAND_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.entry = response.data.accountContext.brand;
          this.extraData = response.data;
          if (this.withType) {
            this.entry.brandType = this.withType;
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    createServerEntry: function(brand) {
      // console.log("BRAND", brand, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(brand, this.entry.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: CREATE_ACCOUNT_BRAND_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(brand, this.entry.validations)
          }
        })
        .then(response => {
          var errors = response.data.createBrand.errors

          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created", response.data.createBrand.brand);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError){
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors){
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.createServerEntry(this.entry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_BRAND_QUERY = gql `
  {
    accountContext {
      brand {
        id
        name
        brandType
        validations
      }
      allAccountBrandTypes
    }
  }
`;

const CREATE_ACCOUNT_BRAND_MUTATION = gql `
  mutation($input: BrandCreateInputObject!) {
    createBrand(input: $input) {
      brand {
        id
        name
        brandType
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
